import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Context } from "context/AuthContext";
import "./styles.scss";

import Button from "components/_base/Button";
import { Col, Form, Row, Alert } from "react-bootstrap";
import { GET_LIST_USUARIO, POST_USUARIO_UPDATE } from "services/Usuario";

const ContentUsuarioUpdate = () => {
  const valorInicial = {
    usuarioId: 0,
    nome: "",
    email: "",
    phoneNumber: "",
    ativo: "",
    PageSize: 25,
    PageNumber: 1,
  };

  const { showLoader } = useContext(Context);
  const [errors, setErrors] = useState([]);
  const [usuario, setUsuario] = useState(valorInicial);

  const location = useLocation();
  const pageQuery = new URLSearchParams(location.search);
  const id = pageQuery.get("id");
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      showLoader(true);
      if (id != null) {
        const { value } = await GET_LIST_USUARIO({ UsuarioId: id });
        if (value) {
          setUsuario(value.data[0]);
        }
      }

      showLoader(false);
    })();
  }, [location.search]);

  const handleChange = (e) => {
    setUsuario({ ...usuario, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    showLoader(true);

    const errors = validate();
    if (errors.length > 0) {
      setErrors(errors);
      showLoader(false);
      return;
    } else {
      setErrors([]);
    }

    const { value } = await POST_USUARIO_UPDATE(usuario);

    if (value) {
      navigate("/admin/usuarios");
    } else {
      setErrors([{ message: "Erro ao salvar usuário." }]);
    }

    showLoader(false);
  };

  const validate = () => {
    let errorsValidation = [];
    !usuario.nome && errorsValidation.push("O campo Nome é obrigatório.");
    !usuario.usuarioId &&
      errorsValidation.push("O campo Tipo de usuário é obrigatório.");
    let validarEmail = /\S+@\S+\.\S+/;
    if (!usuario.email || !validarEmail.test(usuario.email)) {
      !usuario.email && errorsValidation.push("O campo Email é obrigatório.");
    }

    if (!errorsValidation.length) {
      setErrors([]);
      return true;
    }
    setErrors(errorsValidation);
    return false;
  };

  return (
    <>
      <div className="admin-usuario-container">
        <div className="admin-header">
          <h1>Editar usuário</h1>
        </div>
        <div className="admin-usuario-content-wrapper">
          <div className="admin-usuario-content">
            {/* <hr /> */}
            <Form>
              {errors.length > 0 && (
                <Alert variant="danger">
                  {errors.map((erro) => (
                    <p key={erro.nome}>{erro.message}</p>
                  ))}
                </Alert>
              )}
              <hr />
              <Form.Group as={Row}>
                <Col sm="2">
                  <Form.Label column className="mb-3">
                    Id
                  </Form.Label>
                </Col>
                <Col sm="6">
                  <Form.Control
                    name="usuarioId"
                    type="number"
                    readOnly
                    disabled
                    value={usuario.usuarioId == null ? "" : usuario.usuarioId}
                    onChange={handleChange}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Col sm="2">
                  <Form.Label column className="mb-3">
                    Nome
                  </Form.Label>
                </Col>
                <Col sm="6">
                  <Form.Control
                    name="nome"
                    type="text"
                    readOnly
                    disabled
                    value={usuario?.nome == null ? "" : usuario.nome}
                    onChange={handleChange}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Col sm="2">
                  <Form.Label column className="mb-3">
                    Email
                  </Form.Label>
                </Col>
                <Col sm="6">
                  <Form.Control
                    name="email"
                    type="email"
                    readOnly
                    disabled
                    value={usuario.email == null ? "" : usuario.email}
                    onChange={handleChange}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Col sm="2">
                  <Form.Label column className="mb-3">
                    Telefone
                  </Form.Label>
                </Col>
                <Col sm="6">
                  <Form.Control
                    name="phoneNumber"
                    type="text"
                    readOnly
                    disabled
                    value={
                      usuario.phoneNumber == null ? "" : usuario.phoneNumber
                    }
                    onChange={handleChange}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column className="mb-3">
                  Situação
                </Form.Label>
                <Col sm="10">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={usuario.ativo}
                      onChange={() =>
                        setUsuario({ ...usuario, ativo: !usuario.ativo })
                      }
                      id="ativo"
                    />
                    <label className="form-check-label" htmlFor="ativo">
                      Ativo
                    </label>
                  </div>
                </Col>
              </Form.Group>
            </Form>
            <Row>
              <Form.Label column className="mb-3" />
              <Col sm="10">
                <Button className="btn-salvar" onClick={handleSave}>
                  Salvar
                </Button>
              </Col>
            </Row>
            <hr />
            <Button
              className={"btn-voltar"}
              onClick={() => navigate("/admin/usuarios")}
            >
              &lt; Voltar
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContentUsuarioUpdate;
